import Typography from '@mui/material/Typography'
import makeStyles from '@mui/styles/makeStyles'
import { string, element } from 'prop-types'
import { colors } from '@global/constants'

const useStyles = makeStyles(() => ({
  titleSpacing: {
    marginBottom: '15px',
    display: 'block',
    marginRight: '116px',
    marginLeft: '116px',
    textAlign: 'center',
  },
  icon: {
    marginBottom: '10px',
    color: colors.blue.smokey,
    display: 'block',
  },
  actionButton: {
    marginTop: '15px',
  },
}))

export const ZeroState = ({ title = '', description = '', icon = null, actionButton = '' }) => {
  const classes = useStyles()

  return (
    <div style={{ textAlign: 'center' }}>
      {icon && <div className={classes.icon}>{icon}</div>}
      <Typography variant="h4" className={classes.titleSpacing}>
        {title}
      </Typography>
      <Typography variant="body2" className={classes.titleSpacing}>
        {description}
      </Typography>
      {actionButton && <div className={classes.actionButton}>{actionButton}</div>}
    </div>
  )
}
ZeroState.propTypes = {
  title: string.isRequired,
  description: string,
  icon: element || null,
  actionButton: string,
}
